<span class="countdown" [ngClass]="{ 'alert-color': isAlert }">{{ displayTimer }}</span>
